import type {SanityProductIcons, SanityProductIcon} from '../../types';
import {Image} from '@shopify/hydrogen';
import clsx from 'clsx';

type ProductIconsProps = {
  icons: SanityProductIcons;
  hasSmallerIcons?: boolean;
};

export default function ProductIcons(props: ProductIconsProps) {
  const {primarySpecies, secondarySpecies, primaryLocation, secondaryLocation} =
    props.icons;

  return (
    <div className="flex pt-2">
      {primarySpecies && (
        <ProductIcon
          {...primarySpecies}
          isPrimary
          hasSmallerIcons={props.hasSmallerIcons}
        />
      )}
      {secondarySpecies && (
        <ProductIcon
          {...secondarySpecies}
          hasSmallerIcons={props.hasSmallerIcons}
        />
      )}
      {primarySpecies && primaryLocation && (
        <div className="mx-1 h-5 w-[1px] self-center bg-blue-grey" />
      )}
      {primaryLocation && (
        <ProductIcon
          {...primaryLocation}
          isPrimary
          hasSmallerIcons={props.hasSmallerIcons}
        />
      )}
      {secondaryLocation && (
        <ProductIcon
          {...secondaryLocation}
          hasSmallerIcons={props.hasSmallerIcons}
        />
      )}
    </div>
  );
}

function ProductIcon(
  props: SanityProductIcon & {isPrimary?: boolean; hasSmallerIcons?: boolean},
) {
  let hoverLabel;

  if (props.isPrimary && props.iconType === 'species') {
    hoverLabel = `Primary target: ${props.iconName}`;
  } else if (props.iconType === 'species') {
    hoverLabel = `Secondary target: ${props.iconName}`;
  } else if (props.isPrimary && props.iconType === 'location') {
    hoverLabel = `Primary location: ${props.iconName}`;
  } else {
    hoverLabel = `Secondary location: ${props.iconName}`;
  }

  return (
    <div
      key={props.iconName}
      className={clsx('group/icon relative', {
        'h-8 w-8': props.hasSmallerIcons,
        'h-10 w-10': !props.hasSmallerIcons,
      })}
    >
      {props.iconImage && <Image data={props.iconImage} alt={props.iconName} />}
      <span className="pointer-events-none absolute -bottom-10  left-1/2 block w-auto -translate-x-1/2 whitespace-nowrap rounded-[8px] bg-light-grey px-3 py-2 text-center opacity-0 transition-opacity delay-300 duration-300 ease-in-out group-hover/icon:lg:opacity-100">
        {hoverLabel}
      </span>
    </div>
  );
}
